import React from "react";
import { Button } from "react-bootstrap";
import { getPubAbbr } from "@revbox/helpers-fe";
import { brendingActionButtons } from "@revbox/localization";
import { TaxonomyModule } from "../../../../../modules/taxonomy";
import { useCookiesContext } from "../../../../../contexts/CookiesContext";

export function ActionRenderer({ value }) {
  const { getLanguageAbbr } = useCookiesContext();
  const language = getLanguageAbbr();

  if (!value) {
    return null;
  }

  const status = value.toUpperCase();

  if (status === "INACTIVE" || status === "DRAFT") {
    return (
      <button className="btn bg-success btn-sm text-white" style={{marginLeft: '5px', width: '100px'}}>
        {brendingActionButtons[language].startBidding}
      </button>
    );
  } else {
    return (
      <div>
        <Button variant="outline-primary" size="sm" className="" style={{marginLeft: '5px', width: '100px'}}>
          {brendingActionButtons[language].updateBid}
        </Button>
      </div>
    );
  }
}

export function ActionCellColumnHeaderTooltipRenderer() {
  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);

  return taxonomy.tooltips.ppc_branding_column_headers.action;
}

export function ActionCellTooltipRenderer({ value }) {
  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);

  if (!value) {
    return null;
  }
  
  const status = value.toUpperCase();

  if (status === "INACTIVE" || status === "DRAFT") {
    return taxonomy.tooltips.ppc_branding_column_inlines.action.start_bidding;
  } else {
    return taxonomy.tooltips.ppc_branding_column_inlines.action.update_bid;
  }
}
  
